<!--
 * @Author: your name
 * @Date: 2021-03-03 09:39:17
 * @LastEditTime: 2021-03-03 16:38:18
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \aioc-vue\src\components\login\bindTel.vue
-->

<template>
    <div class="bind-wapper" :style="{height:screenHeight + 'px'}" v-if="isClose">
       <div class="bind-box">
            <h1>绑定手机号 <i class="el-icon-circle-close" @click="close"></i></h1>
            <div class="el-input-info">手机号：<el-input v-model="phone" placeholder="请输入手机号"></el-input></div>
            <div class="el-input-info">验证码：<el-input v-model="code"></el-input> <input type="button" class="getcode" @click="GetSmsSend" v-model="Ytxfont"></div>
            <el-button class="Ai-btn" @click="handleSure">确定</el-button>
       </div>
    </div>
</template>

<script>
import {getBindMobileApi,getSmsSendApi} from './../../api/api'
export default {
    props:['isShow'],
    data(){
        return {
            screenHeight: window.innerHeight,   //屏幕高度
            phone: '',
            code: '',
            isClose: true,
            Ytxfont:'发送验证码',
            time_len:'',
            Traem: true,      
        }
    },
    methods: {
        close(){
            this.isClose = false
            window.sessionStorage.setItem('flag',2)     //flag为1：显示弹窗，为2不显示
        },

        handleSure(){
             if(!this.code){
                this.$message.warning('验证码不能为空')
                return false
            }
            const params = {
                mobile:this.phone,
                code:this.code,
            }
            getBindMobileApi(params).then(res => {
                if(res.data.code == 0){
                    this.$message.success('手机号绑定成功')
                    this.close()
                }else {
                    this.$message.warning(res.data.msg)
                }
            }).catch(err => {
                // console.log(err)
            })
        },

         /**
       * @description: 获取短信验证码
       * @param {number} mobile - 注册手机号
       * @param {string} event - 验证码类型
       */    
        GetSmsSend(){
          if(!this.phone){
            this.$message.warning('请输入手机号')
            return false
          }
          const params = {
            mobile: this.phone,
            event: 'reg'
          }
          getSmsSendApi(params).then(res => {
            if(res.data.code == 0){
              this.time_len = res.data.data.time_len
              this.CountDown(this.time_len - 1)
            }else{
              this.$message.error(res.data.msg)
            }
          }).catch(err => {
            this.$message.error(err)
          })
        },


      /**
      * @description: 倒计时功能处理
      * @param {Number} time - 传入时长秒 
      */
      CountDown (time) {
        if (this.Traem) {
            this.Traem = false;
            let than=this
            than.timeName = setInterval(function() {
            if (time == 1) {
                than.Traem = true;
                than.Ytxfont = "发送验证码";
                clearInterval(than.timeName);
            } else {
                time--;
                than.Ytxfont = `重新获取 ${time}s`;
            }
            }, 1000);
        } else {
            // console.log("请稍后重试")
        }
      },

    }
}
</script>

<style lang="scss" scoped>
.bind-wapper {
    width: 100%;
    background-color:rgba(64,60,60,.7);
    position: fixed;
    top: 0;
    z-index: 113;
    .bind-box {
        width: 500px;
        height: 300px;
        background-color: #fff;
        position: absolute;
        top: 35%;
        left: 50%;
        margin-left: -250px;
        padding: 0 30px;
        text-align: center;
        h1 {
            line-height: 40px;
            margin: 20px 0;
            .el-icon-circle-close {
                float: right;
                margin-right: -20px;
                margin-top: -10px;
            }
        }
        .el-input-info {
            text-align: center;
            position: relative;
            .getcode {
                width: 85px;
                position: absolute;
                right:60px;
                top: 23px;
                cursor: pointer;
                background-color: #fff;
            }
        }
        >>> .el-input {
            width: 65%;
            margin:10px 10px;
        }
        .Ai-btn {
            margin-top: 20px;
        }
    }
    .el-button:hover {
        color: #fff;
        background-color:#4165ff;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/login/bindTel.vue